export const releaseVersion: string = '1.187.0';
